import React from "react";

export type AfishaTag = {
  id: number;
  name: string;
  count: number;
};

type AfishaTagsPickerProps = {
  tags: AfishaTag[];
  selectedTagId: number | null;
  loading?: boolean;
  onSelect: (tagId: number) => void;
};

export const AfishaTagsPicker = ({
  tags,
  selectedTagId,
  loading,
  onSelect,
}: AfishaTagsPickerProps) => {
  if (loading) {
    return <p className="afisha__status">Загрузка категорий…</p>;
  }

  if (!tags.length) {
    return <p className="afisha__empty">Категории пока недоступны</p>;
  }

  return (
    <div className="afisha__tags" role="listbox" aria-label="Категории">
      {tags.map((tag) => {
        const isActive = tag.id === selectedTagId;
        return (
          <button
            key={tag.id}
            type="button"
            role="option"
            aria-selected={isActive}
            className={
              "afisha__tag" + (isActive ? " afisha__tag--active" : "")
            }
            onClick={() => onSelect(tag.id)}
          >
            {tag.name}({tag.count})
          </button>
        );
      })}
    </div>
  );
};
